import React from 'react';

//Componentes auxiliares:
import InfoItem from './auxiliars/InfoItem';
import CustomCard from './auxiliars/CustomCard';

//Scripts auxiliares:
import { rolesList } from './scripts/rolesDescription';

let InfoCard = (props) => {
    return (
        <CustomCard title="Notación" style={{ marginBottom: 10 }}>
            <ul className="list-unstyled team-members">
                <InfoItem rol={rolesList[0]} />
                <InfoItem rol={rolesList[1]} />
                <InfoItem rol={rolesList[2]} />
            </ul>
        </CustomCard>
    );
}

export default InfoCard;